/**
 * @author chargoyao
 *
 * UpdateAdminUserTip Component
 *
 * @props UpdateAdminUserTipDialogOpen {boolean} if open tip.
 * @props closeUpdateAdminUserTipDialog {function} when user click `close` button function.
 * @props continue {function} when user click the `confirmation` button go ahead to do something.
 * @props continueLabel {string} confirmation button label string.
 * @props children {node} the node which you want to append.
 * @property closeLabel {string} close button label string
 * @property ifHiddenContinueButton {boolean} if true hidden continue button
 */
import React, { Component } from 'react';
import Dialog from 'material-ui/Dialog';
import Clear from 'material-ui/svg-icons/content/clear';
import FlatButton from 'material-ui/FlatButton';
import { primaryColor } from "../../utils/utility";
import {buttonBlueColor} from "../../utils/utility"

// css
import './suspend-user.css';

class UpdateAdminUserTip extends Component {
  closeDialog() {
    this.props.closeUpdateAdminUserTipDialog();
  }
  confirmSuspendUser() {
    // TODO: continue button been clicked
    this.closeDialog();
    this.props.continue();
  }
  render() {
    const actions = [
      <a className={this.props.ifHiddenContinueButton ? "btn btn-link" : "btn btn-link pull-left"} style={{ marginLeft: '0em', background: this.props.ifHiddenContinueButton ? buttonBlueColor() : '', color: this.props.ifHiddenContinueButton ? 'white' : '', marginBottom: this.props.ifHiddenContinueButton ? '1em' : '' }}
        onClick={(e) => { this.closeDialog() }} >{this.props.closeLabel || 'Cancel'}</a>,
      <FlatButton
        label={this.props.continueLabel}
        style={{ fontSize: '14px', color: 'white ', display: this.props.ifHiddenContinueButton ? 'none' : '' }}
        backgroundColor={primaryColor()}
        disabled={false}
        hoverColor={primaryColor()}
        onClick={() => this.confirmSuspendUser()}
      />
    ]
    return (
      <div className="suspend-user">
        <Dialog
          open={this.props.UpdateAdminUserTipDialogOpen}
          autoScrollBodyContent={true}
          contentStyle={{ width: '45%' }}
          bodyStyle={{ border: 'none' }}
          style={{ zIndex: '1600', paddingRight:'5%', top: this.props.ifHiddenContinueButton ? '-30%' : '' }}
          actions={actions}
          actionsContainerStyle={{ border: 'none', textAlign: this.props.ifHiddenContinueButton ? 'center' : 'right', marginTop: '-20px'}}
          actionsContainerClassName="update-admin-tip-actions"
        >
          <Clear
            style={{ position: 'absolute', right: '0.7em', cursor: 'pointer', top: '0.4em' }}
            onClick={() => this.closeDialog()}
          />
          {this.props.children}
        </Dialog>
      </div>
    )
  }
}

export default UpdateAdminUserTip;


// WEBPACK FOOTER //
// ./src/components/Employees/UpdateAdminUserTip.jsx